///<reference path="../../../../../node_modules/@angular/core/src/linker/view_container_ref.d.ts"/>
import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {BingMapMarker} from "../../bing-map-marker";
import {BingMapService} from "../../service/bing-map.service";
import {BingMapsLoaderService} from "../../service/bing-maps-loader.service";

@Component({
  selector: "app-bing-map",
  templateUrl: "./bing-map.component.html",
  styleUrls: ["./bing-map.component.css"]
})
export class BingMapComponent implements OnInit, OnChanges {

  @ViewChild("map") myMap;

  @Input() showRoute = true;

  private map: Microsoft.Maps.Map;

  @Input() markers: BingMapMarker[] = [];

  mapReady = false;

  constructor(private bingService: BingMapService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.markers = this.markers.filter(m => !m.online);
    if (this.mapReady) {
      this.bingService.clearPushpins();
      this.bingService.addPushpins(this.markers);
    }
  }

  ngOnInit(): void {
    BingMapsLoaderService.load()
      .then(res => {
        this.map = this.bingService.generateMap(this.myMap.nativeElement, undefined, this.markers, this.showRoute, true);
        this.mapReady = true;
      });
  }


}
